import { render, staticRenderFns } from "./readyToDelivery.vue?vue&type=template&id=45061b52&"
import script from "./readyToDelivery.vue?vue&type=script&lang=js&"
export * from "./readyToDelivery.vue?vue&type=script&lang=js&"
import style0 from "./readyToDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports